// Route a remote image through Next's built-in image optimizer (resize + re-encode to a smaller
// format + on-disk cache) so a native <img> — which we use where we need natural-ratio sizing that
// next/image's fixed-box layout can't give — downloads the small optimized version instead of the
// multi-MB original. `width` must be one of next.config's configured device sizes.
export function optimizedImage(url: string, width = 1200, quality = 75): string {
  if (!url) return url;
  return `/_next/image?url=${encodeURIComponent(url)}&w=${width}&q=${quality}`;
}
